










import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class AppPdfViewer extends Vue {
  @Prop() readonly uri: string
  @Prop({ default: false }) fullUri: boolean

  protected pdfJsUriBase = '/live/common/assets/pdfjs/web/viewer.html?file='

  created () {
    this.pdfJsUriBase += this.fullUri ? '' : '/live/'
  }

  get fullUrl () {
    // Need to encode the URL template
    // https://github.com/mozilla/pdf.js/wiki/Frequently-Asked-Questions#can-i-specify-a-different-pdf-in-the-default-viewer
    return this.pdfJsUriBase + (encodeURIComponent(this.uri))
  }
}
